<template>
  <Modal
    class="modalCaasDownload"
    :show-modal="showCaasDownloadModal"
    @close="toggleCaasDownloadModal"
  >
    <template #header>
      <TitleRegular title="Preparing file" />
      <TextSmall>
        The following document is being prepared and will be sent to your email
        address soon!
      </TextSmall>
    </template>
    <template #body>
      <img
        class="modalCaasDownloadImg"
        :src="require(`@/assets/images/caas_download.png`)"
      />
      <TextSmall>Product description - Phone.txt</TextSmall>
    </template>
    <template #footer>
      <BtnsWrapperVertical>
        <BtnPrimary title="Ok" @click="toggleCaasDownloadModal" />
      </BtnsWrapperVertical>
    </template>
  </Modal>
</template>
<script setup>
import BtnPrimary from '@/components/shared/btn/BtnPrimary'
import BtnsWrapperVertical from '@/components/shared/btn/BtnsWrapperVertical'
import TextSmall from '@/components/shared/font/text/TextSmall'
import TitleRegular from '@/components/shared/font/title/TitleRegular'
import Modal from '@/components/shared/Modal'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const showCaasDownloadModal = computed(
  () => store.state.modals.showCaasDownloadModal
)
const toggleCaasDownloadModal = () =>
  store.commit('modals/toggleCaasDownloadModal')
</script>
<style lang="scss">
.modalCaasDownload {
  .modal-container {
    &::-webkit-scrollbar {
      display: none !important; /* Chrome Safari */
    }

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    .modal-header {
      text-align: center;
      .textSmall {
        margin-top: 8px;
      }
    }
    .modal-body {
      margin: 2rem 0;
      text-align: center;
      .modalCaasDownloadImg {
        width: 20%;
      }
      .textSmall {
        background: #f3f6fa;
        margin: 1rem;
        padding: 0.5rem 0;
        color: #2c3fd5 !important;
      }
    }
    .btnsWrapper {
      width: 200px;
      margin: auto;
    }
  }
}
</style>
